module.exports = __webpack_public_path__ + "static/media/U1-T2-2-1.080a3857.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/U1-T2-2-1.mp4
// module id = 536
// module chunks = 0